import { Button, Col, Modal, Row } from "react-bootstrap";
import {
  generateForm, generateInitValues,
  generateValidationSchema,
} from "../../../../utils/AppFunction";
import React, { Dispatch, SetStateAction, useContext, useEffect, useState } from "react";
import { AppContext } from "../../../../appContext/AppContext";
import { XayDungKeHoachContext } from "../HoiChanKhamBenh";
import { Formik, Form } from "formik";
import WfButton from "../../../../workflows/components/WfButton";
import { IconButtonSave } from "../../../../component/IconSvg";
import { TypeKeHoach } from "../models/KeHoachModel";
import GenerateFormComponent from "../../../../component/generate-form/GenerateFormHTMLNoValid";
import DynamicComponent from "../../../../component/GenerateDynamicComponent";
import LabelRequired from "../../../../component/LabelRequired";
import AutocompleteObjectV2 from "../../../../component/AutocompleteObjectV2";
import TableNhanLuc from "./TableNhanLuc";
import {
  TYPE_KE_HOACH_DAO_TAO
} from "../../../../quan-ly-khao-sat/Components/danh-sach-ke-hoach/constants/constansKeHoach";
import { CODE, MAX_PAGE_SIZE, TYPE_WH } from "../../../../utils/Constant";
import { formatDateDTO } from "../../../../utils/FormatUtils";
import { addPhieuKeHoach, searchOptionNhanVien, searchOptionVaiTro, updatePhieuKeHoach } from "../services/services";
import { toast } from "react-toastify";
import ModelHeader from "../../../../component/ModelHeader";
import { searchdsNhanSu } from "../../ho-tro-ky-thuat/services/services";
import { STATUS } from "../../../../quan-ly-khao-sat/const/QuanLyCDT";

interface Props {
  show: boolean;
  onHide: () => void;
  initialValues: any;
  setInitialValues: Dispatch<SetStateAction<any>>
  warehouseId?: any;
  type: TypeKeHoach;
}

// Định nghĩa các type cho nhân lực
const STAFF_TYPES = {
  TUYEN_TREN: 'tuyenTren',
  TUYEN_DUOI: 'tuyenDuoi'
};

const DialogBoSungThongTinCaBenh = (props: Props) => {
  const { show, onHide, warehouseId, setInitialValues, initialValues, type } = props;
  const { setIsLoading } = useContext(AppContext);
  const { dsKeHoach, setDsKeHoach, detailPhieuKeHoach, setDetailPhieuKeHoach } = useContext(XayDungKeHoachContext);
  const [isView, setIsView] = useState<boolean>(initialValues?.statusCode === "approved_done");
  const [listJsonGenerate, setListJsonGenerate] = useState<any>([]);
  const [initialValuesFormThemVT, setInitialValuesFormThemVT] = useState<any>({});

  // Thay đổi cấu trúc dataTable - chỉ có batchStaffList
  const [dataTable, setDataTable] = useState<any>({
    batchStaffList: []
  });

  const [thanhVien, setThanhVien] = useState<any>([]);
  const [vaiTro, setVaiTro] = useState<any>([]);

  // State cho form tuyến trên
  const [selectedNhanSuTren, setSelectedNhanSuTren] = useState<any>(null);
  const [selectedVaiTroTren, setSelectedVaiTroTren] = useState<any>(null);
  const [editingIndexTren, setEditingIndexTren] = useState<number | null>(null);

  // State cho form tuyến dưới
  const [selectedNhanSuDuoi, setSelectedNhanSuDuoi] = useState<any>(null);
  const [selectedVaiTroDuoi, setSelectedVaiTroDuoi] = useState<any>(null);
  const [editingIndexDuoi, setEditingIndexDuoi] = useState<number | null>(null);

  const handleFormSubmit = async (values: any) => {
    const dataSubmit = {
      ...values?.[type.formThongTinChung],
      type: TYPE_WH.IMPORT,
      doCreation: values?.[type.formThongTinChung]?.id ? formatDateDTO(values?.[type.formThongTinChung]?.doCreation) : formatDateDTO(new Date()),
      listOfInstructions: [...(dsKeHoach || [])].map(item => {
        return (
          {
            ...item,
            id: item?.id || null,
          }
        )
      }),
      ...dataTable,
      trackerCode: type.trackerCode,
      termModelType: type?.formThongTinChung,
    };
    try {
      setIsLoading(true);
      const id = values[type.formThongTinChung]?.id;
      const { data } = id ? await updatePhieuKeHoach(id, dataSubmit) : await addPhieuKeHoach(dataSubmit);
      if (CODE.SUCCESS === data?.code) {
        setIsView(true);
        // setInitialValues && setInitialValues(data?.data);
        // setDetailPhieuKeHoach({
        //   ...data?.data,
        //   statusId: detailPhieuKeHoach.statusId,
        // });
        toast.success(((id) ? "Cập nhật" : "Thêm") + " thành công");
      } else {
        let errorMesage = data?.data?.[0]?.message || "Xảy ra lỗi, vui lòng thử lại!";
        toast.warning(errorMesage);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      toast.warning("Xảy ra lỗi, vui lòng thử lại!");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const getOptions = async () => {
    try {
      const nhanVien = await searchOptionNhanVien({ pageSize: MAX_PAGE_SIZE });
      const vaiTro = await searchOptionVaiTro({ pageSize: MAX_PAGE_SIZE });
      setThanhVien(nhanVien?.data?.data?.content ?? [])
      setVaiTro(vaiTro?.data?.data?.content ?? [])
    } catch (e) {
      console.error("Lỗi khi tải danh sách:", e);
    }
  }

  // Hàm lọc dữ liệu theo type để hiển thị trong bảng
  const getDataByType = (staffType: string) => {
    return dataTable.batchStaffList.filter((item: any) => item?.levelType === staffType);
  };


  const handlerSelectItem = (item: any, lst: any) => {
    const isDuplicate = lst?.some((items: any) => items?.item.code === item.code);
    if (isDuplicate) {
      toast.warning("Đã có nhân sự này!");
      return true
    }
  }

  // Thêm hoặc cập nhật tuyến trên
  const handleAddOrUpdateTuyenTren = () => {
    if (!selectedNhanSuTren || !selectedVaiTroTren) {
      toast.warning('Vui lòng chọn đầy đủ nhân sự và vai trò');
      return;
    }
    if (handlerSelectItem(selectedNhanSuTren, getDataByType(STAFF_TYPES.TUYEN_TREN))) return

    const newItem = {
      id: editingIndexTren !== null ? getDataByType(STAFF_TYPES.TUYEN_TREN)[editingIndexTren]?.id : null,
      batchId: null,
      levelType: STAFF_TYPES.TUYEN_TREN,
      personnelName: selectedNhanSuTren.name || null,
      degreeName: selectedNhanSuTren.chucVu || null,
      positionName: selectedNhanSuTren.department || null,
      currentCapacityName: selectedNhanSuTren?.position || null,
      roleName: selectedVaiTroTren.name || null,
      slipId: initialValues?.slipId || null,
      techTransferInfoId: initialValues?.id || null,
      // Giữ lại để hiển thị trong bảng
      item: selectedNhanSuTren,
    };

    if (editingIndexTren !== null) {
      // Cập nhật
      const itemsOfType = getDataByType(STAFF_TYPES.TUYEN_TREN);
      const itemToUpdate = itemsOfType[editingIndexTren];
      const globalIndex = dataTable.batchStaffList.indexOf(itemToUpdate);

      const updatedList = [...dataTable.batchStaffList];
      updatedList[globalIndex] = newItem;
      setDataTable({ ...dataTable, batchStaffList: updatedList });
      setEditingIndexTren(null);
      toast.success('Cập nhật thành công');
    } else {
      // Thêm mới
      setDataTable({
        ...dataTable,
        batchStaffList: [newItem, ...dataTable.batchStaffList]
      });
      toast.success('Thêm thành công');
    }

    // Reset form
    setSelectedNhanSuTren(null);
    setSelectedVaiTroTren(null);
  };

  // Thêm hoặc cập nhật tuyến dưới
  const handleAddOrUpdateTuyenDuoi = () => {
    if (!selectedNhanSuDuoi || !selectedVaiTroDuoi) {
      toast.warning('Vui lòng chọn đầy đủ nhân sự và vai trò');
      return;
    }
    if (handlerSelectItem(selectedNhanSuTren, getDataByType(STAFF_TYPES.TUYEN_DUOI))) return
    const newItem = {
      id: editingIndexDuoi !== null ? getDataByType(STAFF_TYPES.TUYEN_DUOI)[editingIndexDuoi]?.id : null,
      batchId: null,
      levelType: STAFF_TYPES.TUYEN_DUOI,
      personnelName: selectedNhanSuDuoi.name || null,
      degreeName: selectedNhanSuDuoi.chucVu || null,
      positionName: selectedNhanSuDuoi.department || null,
      currentCapacityName: selectedNhanSuDuoi?.position || null,
      roleName: selectedVaiTroDuoi.name || null,
      slipId: initialValues?.slipId || null,
      techTransferInfoId: initialValues?.id || null,
      // Giữ lại để hiển thị trong bảng
      item: selectedNhanSuDuoi,
    };

    if (editingIndexDuoi !== null) {
      // Cập nhật
      const itemsOfType = getDataByType(STAFF_TYPES.TUYEN_DUOI);
      const itemToUpdate = itemsOfType[editingIndexDuoi];
      const globalIndex = dataTable.batchStaffList.indexOf(itemToUpdate);

      const updatedList = [...dataTable.batchStaffList];
      updatedList[globalIndex] = newItem;
      setDataTable({ ...dataTable, batchStaffList: updatedList });
      setEditingIndexDuoi(null);
      toast.success('Cập nhật thành công');
    } else {
      // Thêm mới
      setDataTable({
        ...dataTable,
        batchStaffList: [newItem, ...dataTable.batchStaffList]
      });
      toast.success('Thêm thành công');
    }

    // Reset form
    setSelectedNhanSuDuoi(null);
    setSelectedVaiTroDuoi(null);
  };

  // Sửa tuyến trên
  const handleEditTuyenTren = (row: any, index: number) => {
    setSelectedNhanSuTren(row.item);
    setSelectedVaiTroTren(row.vaiTro);
    setEditingIndexTren(index);
  };

  // Xóa tuyến trên
  const handleDeleteTuyenTren = (index: number) => {
    const itemsOfType = getDataByType(STAFF_TYPES.TUYEN_TREN);
    const itemToDelete = itemsOfType[index];

    const updatedList = dataTable.batchStaffList.filter((item: any) => item !== itemToDelete);
    setDataTable({ ...dataTable, batchStaffList: updatedList });
    toast.success('Xóa thành công');
  };

  // Sửa tuyến dưới
  const handleEditTuyenDuoi = (row: any, index: number) => {
    setSelectedNhanSuDuoi(row.item);
    setSelectedVaiTroDuoi(row.vaiTro);
    setEditingIndexDuoi(index);
  };

  // Xóa tuyến dưới
  const handleDeleteTuyenDuoi = (index: number) => {
    const itemsOfType = getDataByType(STAFF_TYPES.TUYEN_DUOI);
    const itemToDelete = itemsOfType[index];

    const updatedList = dataTable.batchStaffList.filter((item: any) => item !== itemToDelete);
    setDataTable({ ...dataTable, batchStaffList: updatedList });
    toast.success('Xóa thành công');
  };

  const getDsItems = async () => {
    try {
      const data = await searchdsNhanSu(initialValues?.id);
      setDataTable({ batchStaffList: data?.data?.data ?? [] })
    } catch (e) {
      console.error("Lỗi khi tải danh sách nhân sự:", e);
    }
  }

  useEffect(() => {
    initialValues?.id && getDsItems();
  }, [initialValues?.id]);

  useEffect(() => {
    updateForm();
    getOptions();
  }, []);

  const updateForm = async () => {
    if (!type?.formThongTinChung) return;
    const data = await generateForm(type?.formThongTinChung, setIsLoading);
    setListJsonGenerate(data || []);
    setInitialValues({ ...generateInitValues(data), ...initialValues?.slip, ...initialValues });
  };

  const columnsDkDaoTao = [
    {
      name: "STT",
      field: "",
      headerStyle: {
        width: 80,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => stt,
    },
    ...(!isView ?
      [
        {
          name: "Thao tác",
          field: "",
          headerStyle: {
            width: 100,
          },
          cellStyle: {
            textAlign: "center",
            justifyContent: "center"
          },
          render: (row: any, index: number, stt: number) =>
            <div className="d-flex justify-content-center">
              <i
                onClick={(e) => handleEditTuyenTren(row, index)}
                className="bi bi-pencil-square text-navy cursor-pointer"
                style={{ cursor: 'pointer', marginRight: '10px' }}
              ></i>
              <i
                onClick={(e) => handleDeleteTuyenTren(index)}
                className="bi bi-trash3-fill text-danger cursor-pointer"
                style={{ cursor: 'pointer' }}
              ></i>
            </div>
        },
      ] : []),

    {
      name: "Họ tên",
      field: "personnelName",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any, index: number, stt: number) => row.personnelName || row.item?.personnelName || '',
    },
    {
      name: "Chức danh",
      field: "degreeName",
      headerStyle: {
        minWidth: 200,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any, index: number, stt: number) => row.degreeName || row.item?.degreeName || '',
    },
    {
      name: "Đơn vị",
      field: "positionName",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any, index: number, stt: number) => row.positionName || row.item?.positionName || '',
    },
    {
      name: "Trình độ chuyên môn",
      field: "currentCapacityName",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any, index: number, stt: number) => row.currentCapacityName || row.item?.currentCapacityName || '',
    },
    {
      name: "Vai trò",
      field: "roleName",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any, index: number, stt: number) => row.roleName || row.item?.roleName || '',
    },
  ];

  const columnsTuyenDuoi = [
    {
      name: "STT",
      field: "",
      headerStyle: {
        width: 80,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => stt,
    },
    ...(!isView ?
      [
        {
          name: "Thao tác",
          field: "",
          headerStyle: {
            width: 100,
          },
          cellStyle: {
            textAlign: "center",
            justifyContent: "center"
          },
          render: (row: any, index: number, stt: number) =>
            <div className="d-flex justify-content-center">
              <i
                onClick={(e) => handleEditTuyenDuoi(row, index)}
                className="bi bi-pencil-square text-navy cursor-pointer"
                style={{ cursor: 'pointer', marginRight: '10px' }}
              ></i>
              <i
                onClick={(e) => handleDeleteTuyenDuoi(index)}
                className="bi bi-trash3-fill text-danger cursor-pointer"
                style={{ cursor: 'pointer' }}
              ></i>
            </div>
        },
      ] : []),

    {
      name: "Họ tên",
      field: "personnelName",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any, index: number, stt: number) => row.personnelName || row.item?.personnelName || '',
    },
    {
      name: "Chức danh",
      field: "degreeName",
      headerStyle: {
        minWidth: 200,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any, index: number, stt: number) => row.degreeName || row.item?.degreeName || '',
    },
    {
      name: "Đơn vị",
      field: "positionName",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any, index: number, stt: number) => row.positionName || row.item?.positionName || '',
    },
    {
      name: "Trình độ chuyên môn",
      field: "currentCapacityName",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any, index: number, stt: number) => row.currentCapacityName || row.item?.currentCapacityName || '',
    },
    {
      name: "Vai trò",
      field: "roleName",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any, index: number, stt: number) => row.roleName || row.item?.roleName || '',
    },
  ];

  return (
    <Modal
      centered
      show={show}
      size="xl"
      fullscreen
      className="page-full spaces h-calc-vh-50 dialog-coso-kb-cb"
    >
      <Formik
        enableReinitialize
        validateOnChange={true}
        validateOnBlur={true}
        initialValues={{ [type.formThongTinChung]: initialValues }}
        validationSchema={generateValidationSchema(listJsonGenerate, type.formThongTinChung)}
        onSubmit={handleFormSubmit}
      >
        {({ values, touched, errors, setValues, handleChange, handleSubmit, setFieldValue }) => (
          <Form onSubmit={handleSubmit}>
            <ModelHeader onHide={onHide} title={`Bổ sung thông tin ca bệnh hội chẩn`} />
            <Modal.Body className="spaces p-0 bg-white">
              <div className="spaces px-10">
                <GenerateFormComponent
                  isView={isView}
                  listFieldAuto={listJsonGenerate}
                  handleChange={handleChange}
                  setValues={setValues}
                  values={values}
                  touched={touched}
                  errors={errors}
                  lstSelectedRenderButton={dsKeHoach}
                  setFieldValue={setFieldValue}
                  modelID={type.formThongTinChung}
                  customComponent={DynamicComponent}
                  warehouseId={warehouseId}
                />

                <div className="spaces fw-bold">
                  <hr />
                </div>

                {/* TUYẾN TRÊN */}
                <h4 className="text-title fw-bold fs-5 spaces mb-5">Thành viên tham gia hội chẩn tuyến trên</h4>
                {!isView && <Row>
                  <Col lg={1} className={`spaces`}>
                    <div className="spaces pt-10 min-w-135">
                      <div className={`spaces mt-1`}>
                        <LabelRequired className="min-w-100px" label={"Nhân sự"} />
                      </div>
                    </div>
                  </Col>
                  <Col lg={4} className={`spaces pl-36`}>
                    <div className="d-flex">
                      <AutocompleteObjectV2
                        options={thanhVien}
                        value={selectedNhanSuTren}
                        isSearchDefauilt={true}
                        name={"WmsCode"}
                        onChange={(options: any) => setSelectedNhanSuTren(options)}
                        className="autocomplete-custom-renderform mt-8 radius spaces width-100 h-29"
                        isClearable={true}
                      />
                    </div>
                  </Col>
                  <Col lg={1} className={`spaces`}>
                    <div className="spaces pt-10 min-w-135">
                      <div className={`spaces mt-1`}>
                        <LabelRequired className="min-w-100px" label={"Vai trò"} />
                      </div>
                    </div>
                  </Col>
                  <Col lg={4} className={`spaces pl-36`}>
                    <div className="d-flex">
                      <AutocompleteObjectV2
                        options={vaiTro}
                        value={selectedVaiTroTren}
                        isSearchDefauilt={true}
                        name={"WmsCode"}
                        onChange={(options: any) => setSelectedVaiTroTren(options)}
                        className="autocomplete-custom-renderform mt-8 radius spaces width-100 h-29"
                        isClearable={true}
                      />
                    </div>
                  </Col>
                  <Col lg={2} className={`spaces`}>
                    <div className="flex mt-2">
                      <Button
                        className="btn-fill spaces min-w-90px btn btn-primary"
                        onClick={handleAddOrUpdateTuyenTren}
                        type="button"
                      >
                        <i className="bi bi-plus-lg text-pri fs-3"></i>
                        {editingIndexTren !== null ? 'Cập nhật' : 'Thêm'}
                      </Button>
                      {editingIndexTren !== null && (
                        <Button
                          className="btn-fill spaces min-w-90px btn btn-secondary ml-2"
                          onClick={() => {
                            setEditingIndexTren(null);
                            setSelectedNhanSuTren(null);
                            setSelectedVaiTroTren(null);
                          }}
                          type="button"
                        >
                          Hủy
                        </Button>
                      )}
                    </div>
                  </Col>
                </Row>}

                <TableNhanLuc
                  columns={columnsDkDaoTao}
                  isView={isView}
                  setInitialValuesFormThemVT={setInitialValuesFormThemVT}
                  dsItems={getDataByType(STAFF_TYPES.TUYEN_TREN)}
                  type={TYPE_KE_HOACH_DAO_TAO.CSHT}
                />

                {/* TUYẾN DƯỚI */}
                <h4 className="text-title fw-bold fs-5 spaces mb-5 mt-20">Thành viên tham gia hội chẩn tuyến dưới</h4>
                {!isView && <Row>
                  <Col lg={1} className={`spaces`}>
                    <div className="spaces pt-10 min-w-135">
                      <div className={`spaces mt-1`}>
                        <LabelRequired className="min-w-100px" label={"Nhân sự"} />
                      </div>
                    </div>
                  </Col>
                  <Col lg={4} className={`spaces pl-36`}>
                    <div className="d-flex">
                      <AutocompleteObjectV2
                        options={thanhVien}
                        value={selectedNhanSuDuoi}
                        isSearchDefauilt={true}
                        name={"WmsCode"}
                        onChange={(options: any) => setSelectedNhanSuDuoi(options)}
                        className="autocomplete-custom-renderform mt-8 radius spaces width-100 h-29"
                        isClearable={true}
                      />
                    </div>
                  </Col>
                  <Col lg={1} className={`spaces`}>
                    <div className="spaces pt-10 min-w-135">
                      <div className={`spaces mt-1`}>
                        <LabelRequired className="min-w-100px" label={"Vai trò"} />
                      </div>
                    </div>
                  </Col>
                  <Col lg={4} className={`spaces pl-36`}>
                    <div className="d-flex">
                      <AutocompleteObjectV2
                        options={vaiTro}
                        value={selectedVaiTroDuoi}
                        isSearchDefauilt={true}
                        name={"WmsCode"}
                        onChange={(options: any) => setSelectedVaiTroDuoi(options)}
                        className="autocomplete-custom-renderform mt-8 radius spaces width-100 h-29"
                        isClearable={true}
                      />
                    </div>
                  </Col>
                  <Col lg={2} className={`spaces`}>
                    <div className="flex mt-2">
                      <Button
                        className="btn-fill spaces min-w-90px btn btn-primary"
                        onClick={handleAddOrUpdateTuyenDuoi}
                        type="button"
                      >
                        <i className="bi bi-plus-lg text-pri fs-3"></i>
                        {editingIndexDuoi !== null ? 'Cập nhật' : 'Thêm'}
                      </Button>
                      {editingIndexDuoi !== null && (
                        <Button
                          className="btn-fill spaces min-w-90px btn btn-secondary ml-2"
                          onClick={() => {
                            setEditingIndexDuoi(null);
                            setSelectedNhanSuDuoi(null);
                            setSelectedVaiTroDuoi(null);
                          }}
                          type="button"
                        >
                          Hủy
                        </Button>
                      )}
                    </div>
                  </Col>
                </Row>}
                <TableNhanLuc
                  columns={columnsTuyenDuoi}
                  isView={isView}
                  setInitialValuesFormThemVT={setInitialValuesFormThemVT}
                  dsItems={getDataByType(STAFF_TYPES.TUYEN_DUOI)}
                  type={TYPE_KE_HOACH_DAO_TAO.CSHT}
                />
              </div>

            </Modal.Body>
            <div className="bottom-button d-flex justify-content-start w-100 bg-white spaces py-6 pl-5">
              {(values.keHoach?.id || detailPhieuKeHoach?.id) && !detailPhieuKeHoach?.isView && (
                <WfButton
                  additionalFunc={(data: any) => {
                    setDetailPhieuKeHoach({
                      ...detailPhieuKeHoach,
                      status: data?.currCode,
                      statusCode: data?.currCode,
                      statusId: data?.currId,
                    });
                    ![STATUS.new_save].includes(data.currCode) && setIsView(true);
                  }}
                  afterSubmit={() => {
                    handleFormSubmit(values)
                  }}
                  handleClick={(data: any) => {
                    ![STATUS.new_save].includes(data.currCode) && setIsView(true);
                  }}
                  tracker={type.trackerCode}
                  onHide={onHide}
                  objectId={values.keHoach?.id || detailPhieuKeHoach?.id}
                />
              )}
              {!isView &&
                <Button type="submit" className="btn btn-fill min-w-120px spaces mx-3">
                  <IconButtonSave /> Lưu
                </Button>
              }
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default DialogBoSungThongTinCaBenh;